/** Текст условий использования.
 *
 *  Устроен так же, как политика обработки данных, и по той же причине:
 *  артефакт репозитория, доступный без сети и меняющийся вместе с кодом.
 *  Разница между двумя документами такая. Политика отвечает на вопрос «что
 *  вы делаете с нашими данными» — это утверждение О КОДЕ, и каждое её слово
 *  проверяемо. Условия отвечают на вопрос «на что мы договорились» — это
 *  обещания и границы, и проверяемы они лишь отчасти.
 *
 *  Отсюда правило для того, кто будет править: обещание, которое можно
 *  сверить с кодом, обязано быть сверено тестом. Обещание, которое сверить
 *  нельзя, должно быть сформулировано так, чтобы его нельзя было нарушить
 *  случайно. «Мы стараемся» — плохо, «мы не обязаны» — хорошо. */
export const TERMS = {
  title: 'Условия использования',
  updated: '2026-09-15',
  sections: [
    {
      heading: 'Коротко',
      paragraphs: [
        'Это тренажёр таблицы умножения для детей. Он бесплатный. Им пользуются по своему усмотрению и на свой риск, а взрослый, заведший учётную запись, отвечает за то, как им пользуются его дети.',
        'Приложение делает один человек. Это не компания, не служба поддержки и не обещание, что завтра всё будет работать так же.',
      ],
    },
    {
      heading: 'Кто по эту сторону',
      paragraphs: [
        'Приложением владеет и распоряжается владелец mathpaw.com. Написать ему можно на privacy@mathpaw.com. Это тот же адрес, что и в политике обработки данных, и отвечает по нему человек.',
      ],
    },
    {
      heading: 'Кто может пользоваться',
      paragraphs: [
        'Учётную запись заводит взрослый — родитель или законный представитель ребёнка. Ребёнок пользуется приложением под присмотром взрослого и своей учётной записи не имеет: профиль ребёнка — это цвет и зверёк внутри записи взрослого, а не отдельный вход.',
        'Заводя профиль, взрослый подтверждает, что он вправе разрешить обработку данных занятий этого ребёнка. Приложение не может это проверить и полагается на слово.',
      ],
    },
    {
      heading: 'Что можно',
      paragraphs: [
        'Пользоваться приложением бесплатно, для себя и своей семьи, сколько угодно.',
        'Забрать занятия ребёнка файлом и загрузить их обратно — на этом же или на другом устройстве. Кнопки «Выгрузить» и «Загрузить» есть на родительском экране.',
        'Удалить профиль ребёнка или всю учётную запись целиком, в любой момент и без объяснений. Удаление учётной записи уносит с сервера и занятия.',
      ],
    },
    {
      heading: 'Чего нельзя',
      paragraphs: [
        'Пытаться получить доступ к чужим данным, обходить правила доступа, нагружать сервер автоматическими запросами или мешать заниматься другим.',
        'Выдавать приложение за своё, продавать доступ к нему или встраивать его в чужой продукт без разрешения владельца.',
        'Загружать в приложение чужие файлы занятий, полученные не от того, кому они принадлежат.',
      ],
    },
    {
      heading: 'Чего мы не обещаем',
      paragraphs: [
        'Приложение предоставляется как есть. Мы не обещаем, что оно доступно постоянно, что занятия никогда не потеряются и что тренажёр научит ребёнка считать.',
        'Мы не обещаем, что оно подходит для школьной отметки, для оценки способностей или для чего-либо, кроме домашних упражнений.',
        'Мы не отвечаем за убытки от того, что приложение было недоступно, ошиблось или потеряло записи. Единственное, что мы можем предложить в таком случае, — исправить и извиниться.',
      ],
    },
    {
      heading: 'Копия на устройстве и копия на сервере',
      paragraphs: [
        'Занятия хранятся в браузере устройства и, если взрослый вошёл, копируются на сервер. Хранилище браузера очищается самим браузером — при нехватке места, при чистке истории, а на iPhone и iPad ещё и после долгого перерыва без захода. Это не отказ приложения, а свойство браузера.',
        'Поэтому единственная надёжная копия — та, что на сервере, и она появляется только после входа. Кто не вошёл, тот держит занятия на одном устройстве и рискует ими сам.',
      ],
    },
    {
      heading: 'Мы можем это закрыть',
      paragraphs: [
        'Владелец вправе изменить приложение, ограничить доступ к нему или прекратить его работу — в том числе полностью и без замены.',
        'Если приложение закрывается насовсем, владелец постарается предупредить об этом заранее по адресу почты учётной записи, чтобы занятия можно было выгрузить файлом. Обещанием срока это не является.',
        'Учётная запись может быть закрыта без предупреждения, если через неё нарушают раздел «Чего нельзя».',
      ],
    },
    {
      heading: 'Изменения условий',
      paragraphs: [
        'Условия меняются вместе с приложением. Дата редакции стоит вверху этой страницы. Продолжая пользоваться приложением после изменения, взрослый принимает новую редакцию; кто не согласен — удаляет учётную запись, и это тоже кнопка на родительском экране.',
      ],
    },
  ],
} as const;
